import { Component, Input, OnInit } from '@angular/core';
import { SubDimensionModel } from 'src/app/model/InstrumentoAutoevaluacion.model';

@Component({
  selector: 'app-ins-autoevaluacion-subdimension',
  templateUrl: './ins-autoevaluacion-subdimension.component.html',
  styleUrls: ['./ins-autoevaluacion-subdimension.component.css']
})
export class InsAutoevaluacionSubdimensionComponent implements OnInit {

  @Input() subDimension : SubDimensionModel;
  @Input() readonly : boolean;
  @Input() isModificable : boolean;
  public isCollapsed = true;

  constructor() { }

  ngOnInit(): void {
  }

}
